import { onEmbedReady } from '@common/onEmbedReady'
import { createRoot } from 'react-dom/client'
import App from './App'

onEmbedReady(function () {
	const container = document.getElementById('app-home-page')
	const root = createRoot(container)
	root.render(<App />)
})
